const ArticleData = [
    {
    field: 'Desarrollo',
    category: ["Fundamentos"],
    image: '/assets/blog-assets/LasComputadorasSoloEntienden0y1/LasComputadorasSoloEntienden0y1.webp',
    title: '¿Por qué las computadoras solo entienden 0 y 1?',
    date:'Abril 23, 2025',
    url: 'LasComputadorasSoloEntienden0y1',
    },
    {
    field: 'Desarrollo',
    category: ["JavaScript"],
    image: '/assets/blog-assets/JavaScript/MetodosArraysJavaScript.webp',
    title: 'Métodos de un array en JavaScript',
    date:'Noviembre 21, 2022',
    url: 'MetodosArrayJavaScript',
    },
    {
    field: 'Desarrollo',
    category: ["JavaScript"],
    image: '/assets/blog-assets/JavaScript/FuncionesJavaScript.webp',
    title: '4 Formas de escribir una función en JavaScript',
    date:'Noviembre 20, 2022',
    url: 'FuncionesJavaScript',
    },
    {
    field: 'Desarrollo',
    category: ["Tailwind"],
    image: '/assets/blog-assets/RecursosTailwind/ResourseTailwind.webp',
    title: 'Colección de recursos para Tailwind',
    date:'Septiembre 07, 2022',
    url: 'ColeccionRecursosTailwind',
    },
    {
    field: 'Desarrollo',
    category: ["Herramientas"],
    image: '/assets/blog-assets/LibrosDesarrolladores/LibrosDesarrolladores.webp',
    title: 'Mejores libros para desarrolladores',
    date:'Septiembre 06, 2022',
    url: 'MejoresLibrosDesarrolladores',
    },
    {
    field: 'Desarrollo',
    category: ["HTML"],
    image: '/assets/blog-assets/HTML.webp',
    title: 'Etiquetas HTML esenciales que debes conocer',
    date:'Julio 25, 2022',
    url: 'EtiquetasHTMLEsenciales',
    },
    {
    field: 'Desarrollo',
    category: ["Herramientas"],
    image: '/assets/blog-assets/Chrome103/Devtools.webp',
    title: 'Novedades en DevTools (Chrome 103)',
    date:'Julio 24, 2022',
    url: 'DevToolsChrome103',
    },
    
// TECNOLOGIA
    {
    field: 'Tecnología',
    category: ['Google'],
    image: '/assets/blog-assets/PixelMadebyGoogle/PixelWatch4MadebyGoogle.webp',
    title: 'Google Pixel Watch 4: potencia, salud y Gemini en tu muñeca',
    date:'Agosto 31, 2025',
    url: 'PixelWatch4MadebyGoogle',
    },
    {
    field: 'Tecnología',
    category: ['Google'],
    image: '/assets/blog-assets/PixelMadebyGoogle/PixelFold2MadebyGoogle.webp',
    title: 'Pixel Fold 2, Watch 4 y Buds 2a: el próximo ecosistema de Google',
    date:'Agosto 9, 2025',
    url: 'PixelFold2-Watch4-Buds2a',
    },
    {
    field: 'Tecnología',
    category: ['Google'],
    image: '/assets/blog-assets/GooglePixel10/Pixel10MadebyGoogle.webp',
    title: 'Pixel 10 y Gemini: el dúo con el que Google planea dominar el 2025',
    date:'Agosto 6, 2025',
    url: 'Pixel10MadebyGoogle',
    },
    {
    field: 'Tecnología',
    category: ['Periféricos'],
    image: '/assets/blog-assets/AsusRogAzoth/AsusRogAzoth.webp',
    title: 'ASUS ROG Azoth: ¿el teclado gaming definitivo?',
    date:'Junio 7, 2025',
    url: 'AsusRogAzoth',
    },
    {
    field: 'Tecnología',
    category: ['Audio','Periféricos'],
    image: '/assets/blog-assets/SonyWH1000XM6/SonyWH1000XM6.webp',
    title: 'WH-1000XM6: Sony redefine el estándar en cancelación de ruido',
    date:'Mayo 28, 2025',
    url: 'SonyWH1000XM6',
    },
    {
    field: 'Tecnología',
    category: ['Consolas'],
    image: '/assets/blog-assets/LaNuevaEraDelGamingPortátil/AsusRogAlly.webp',
    title: 'La nueva era del gaming portátil: ROG Ally, Steam Deck  y Switch 2',
    date:'Abril 20, 2025',
    url: 'LaNuevaEraDelGamingPortátil',
    },
    {
    field: 'Tecnología',
    category: ['Consolas'],
    image: '/assets/blog-assets/NintendoSwitch2/NintendoSwitch2.webp',
    title: 'Nintendo Switch 2 ya es oficial, y viene con todo',
    date:'Abril 14, 2025',
    url: 'NintendoSwitch2',
    },
    {
    field: 'Tecnología',
    category: ['Laptops'],
    image: '/assets/blog-assets/ZenbookA14/ZenbookA14.webp',
    title: 'Zenbook A14 quiere destronar a la MacBook Air',
    date:'Abril 8, 2025',
    url: 'ZenbookA14',
    },
    {
    field: 'Tecnología',
    category: ['Periféricos'],
    image: '/assets/blog-assets/MejoresRatonesGaming2022/MejoresRatonesGaming2022.webp',
    title: 'Mejores Ratones Gaming 2022',
    date:'Agosto 18, 2022',
    url: 'MejoresRatonesGaming2022',
    },

// APPLE
    {
    field: 'Apple',
    category: ['iPhone', 'Apple Intelligence'],
    image: '/assets/blog-assets/iPhone17Pro/iPhone17Pro.webp',
    title: 'iPhone 17 Pro y Pro Max: Poder sin limites',
    date:'Septiembre 27, 2025',
    url: 'AweDroppingiPhone17Pro',
    },
    {
    field: 'Apple',
    category: ['iPhone'],
    image: '/assets/blog-assets/iPhoneAir/iPhoneAir.webp',
    title: 'iPhone Air: la revolución de la ligereza',
    date:'Septiembre 21, 2025',
    url: 'AweDroppingiPhoneAir',
    },
    {
    field: 'Apple',
    category: ['iPhone'],
    image: '/assets/blog-assets/iPhone17/iPhone17.webp',
    title: 'iPhone 17: la evolución que todos esperaban',
    date:'Septiembre 18, 2025',
    url: 'AweDroppingiPhone17',
    },
    {
    field: 'Apple',
    category: ['AirPods'],
    image: '/assets/blog-assets/AppleAweDropping2025/AppleAirPodsPro3.webp',
    title: 'AirPods Pro 3: el gran regreso de los auriculares premium de Apple en 2025',
    date:'Septiembre 8, 2025',
    url: 'AppleAweDroppingAppleAirPodsPro3',
    },
    {
    field: 'Apple',
    category: ['Watch'],
    image: '/assets/blog-assets/AppleAweDropping2025/AppleWatchSE3.webp',
    title: 'Apple Watch SE 3: todo lo que sabemos del reloj más accesible de Apple',
    date:'Septiembre 8, 2025',
    url: 'AppleAweDroppingAppleWatchSE3',
    },
    {
    field: 'Apple',
    category: ['Watch'],
    image: '/assets/blog-assets/AppleAweDropping2025/AppleWatchSeries11.webp',
    title: 'Apple Watch Series 11: Qué Vendrá en el Evento del 9 de Septiembre',
    date:'Septiembre 7, 2025',
    url: 'AppleAweDroppingAppleWatchSeries11',
    },
    {
    field: 'Apple',
    category: ['Watch'],
    image: '/assets/blog-assets/AppleAweDropping2025/AppleWatchUltra3.webp',
    title: 'Apple Watch Ultra 3: la evolución del reloj más extremo de Apple',
    date:'Septiembre 5, 2025',
    url: 'AppleAweDroppingAppleWatchUltra3',
    },
    {
    field: 'Apple',
    category: ['iPhone','Watch','AirPods','iOS', 'iPadOS', 'macOS'],
    image: '/assets/blog-assets/AppleAweDropping2025/AppleAweDropping.webp',
    title: 'Apple “Awe Dropping” 2025: Qué traerá el Evento del 9 de Septiembre',
    date:'Septiembre 5, 2025',
    url: 'AppleAweDropping2025',
    },
    {
    field: 'Apple',
    category: ['iPhone'],
    image: '/assets/blog-assets/iPhone17Colors/iPhone17.webp',
    title: 'iPhone 17: cambios de diseño, colores y mejoras de hardware',
    date:'Agosto 16, 2025',
    url: 'iPhone17DiseñoColoresHardware',
    },
    {
    field: 'Apple',
    category: ['iPhone','MacBook','Watch','Vision Pro','iOS','Apple Intelligence','WWDC'],
    image: '/assets/blog-assets/WWDC2025NovedadesyRumores/WWDC25.webp',
    title: 'WWDC 2025: Todas las novedades confirmadas y los rumores más fuertes',
    date:'Mayo 29, 2025',
    url: 'WWDC2025NovedadesyRumores',
    },
    {
    field: 'Apple',
    category: ['iPhone', 'Apple Intelligence'],
    image: '/assets/blog-assets/iPhone17Air/iPhone17Air.webp',
    title: 'iPhone 17 Air: el modelo más delgado en la historia de Apple',
    date:'Abril 17, 2025',
    url: 'iPhone17Air',
    },
    {
    field: 'Apple',
    category: ['iPhone', 'Apple Intelligence'],
    image: '/assets/blog-assets/iPhone17Pro/iPhone17pro8K.webp',
    title: 'Grabar en 8K desde un iPhone: el 17 Pro lo haría posible',
    date:'Abril 11, 2025',
    url: 'iPhone17Pro8K',
    },
    {
    field: 'Apple',
    category: ['iPhone', 'iOS', 'Apple Intelligence'],
    image: '/assets/blog-assets/iOS184/iOS184.webp',
    title: 'Novedades de iOS 18.4',
    date:'Abril 5, 2025',
    url: 'NovedadesiOS184',
    },
    {
    field: 'Apple',
    category: ['MacBook'],
    image: '/assets/blog-assets/MacBookAirM2Review/MacBookAirM2Review.webp',
    title: 'MacBook Air M2 review',
    date:'Agosto 14, 2022',
    url: 'MacBookAirM2Review',
    },
]

export default ArticleData